import properties from '../../constants/Properties';
import configuration from '../../constants/Configuration';
import { changeTextProperties, updateTextHeight } from '../../actions/CurrentSlideActions';
import platformDetection from '../utils/PlatformDetection';
import saveManager from './SaveManager';

const textSizeUtils = {
    searchText: '',
    textArea: undefined,
    initTextArea() {
        if (this.textArea == undefined) {
            this.textArea = document.createElement('textArea');
            document.body.appendChild(this.textArea);
        }
    },
    isValidSize(y, newHeight) {
        return true; // added for CH-875

        if (platformDetection.isIOS())
            return true;

        if (y + newHeight > configuration.CANVAS_HEIGHT + 10)
            return false;
        else
            return true;
    },
    updateTextWrapperSize(shapeModel, dispatch, isTextAdded) {
        if (!shapeModel)
            return;

        if (isTextAdded && shapeModel.width < properties.TEXT_WIDTH * 1.6) {
            if (platformDetection.isIOS()) {
                var newWidth = 0;
                var textLength = shapeModel.htmlText.length;

                if (textLength <= 10)
                    newWidth = 0;
                else {
                    if (textLength >= 19)
                        newWidth = properties.TEXT_WIDTH * 1.6;
                    else
                        newWidth = shapeModel.width + 10 * (textLength - 10);
                }

                if (newWidth > 0) {
                    dispatch(updateTextHeight(shapeModel.uuid, 0, newWidth));
                    saveManager.isContentChanged(true);
                }
            } else {
                dispatch(updateTextHeight(shapeModel.uuid, 0, shapeModel.width + 10));
                saveManager.isContentChanged(true);
            }
        } else {
            this.initTextArea();

            this.setTextAreaProperties(this.textArea, shapeModel);

            var height = this.textArea.scrollHeight;

            if (height > 0) {
                var newHeight = height + 2 * properties.TEXT_PADDING + 2 * properties.TEXT_INNER_PADDING + 10;

                if (this.isValidSize(shapeModel.y, newHeight)) {
                    dispatch(updateTextHeight(shapeModel.uuid, newHeight));
                    saveManager.isContentChanged(true);
                } else {
                    document.activeElement.blur();
                }
            }

            if (platformDetection.isIOS()) {
                document.body.removeChild(this.textArea);
                this.textArea = undefined;
            }
        }
    },
    count: 0,
    getFontSize(shapeModel, newWidth, newHeight, startWidth, startHeight) { // used to detect the maximum font size for a text wrapped in a specified area
        if (shapeModel.isRichText)
            return this.currentFontSize;
        else
            return this.getFontSizeOld(shapeModel, newWidth, newHeight, startWidth, startHeight);
    },
    getFontSizeOld(shapeModel, newWidth, newHeight, startWidth, startHeight) {
        this.initTextArea();

        this.setTextAreaProperties(this.textArea, shapeModel);

        const initialFontSize = shapeModel.fontSize;
        var currentArea;

        if (startWidth > 0)
            currentArea = startWidth * startHeight;
        else
            currentArea = shapeModel.width * shapeModel.height;

        const newArea = newWidth * newHeight;
        var i;
        var newFontSize = -1;
        var availableHeight = newHeight - 2 * properties.TEXT_INNER_PADDING - 2 * properties.TEXT_PADDING - 5;

        if (currentArea > newArea) {
            for (i=initialFontSize; i > properties.MIN_FONT_SIZE; i--) {
                this.textArea.style.fontSize = i + 'px';

                if (this.textArea.scrollHeight <= availableHeight) {
                    newFontSize = i;
                    break;
                }
            }
        } else {
            for (i=initialFontSize + 1; i < properties.MAX_FONT_SIZE; i++) {
                this.textArea.style.fontSize = i + 'px';

                if (this.textArea.scrollHeight >= availableHeight) {
                    newFontSize = i - 1;
                    break;
                }
            }
        }

        if (platformDetection.isIOS()) {
            document.body.removeChild(this.textArea);
            this.textArea = undefined;
        }

        return newFontSize;
    },
    updateFontSize(shapeModel, newWidth, newHeight, dispatch, endResize, startWidth, startHeight) {
        if (shapeModel.isRichText)
            return;

        if (platformDetection.isEdge() == true) {
            if (endResize == true) {
                this.count = 0;
            } else {
                this.count = this.count + 1;

                if (this.count < 5)
                    return;

                this.count = 0;
            }
        }

        const initialFontSize = shapeModel.fontSize;
        const newFontSize = this.getFontSize(shapeModel, newWidth, newHeight, startWidth, startHeight);

        if (newFontSize > 0 && initialFontSize != newFontSize) {
            dispatch(changeTextProperties(shapeModel, 'fontSize', newFontSize));
            saveManager.isContentChanged(true);
        }
    },
    setTextAreaProperties(textArea, shapeModel) {
        if (!shapeModel)
            return;

        const bold = shapeModel.fontBold ? 'bold' : 'normal';
        const italic = shapeModel.fontItalic ? 'italic' : 'normal';

        textArea.style.width = (shapeModel.width - 2 * properties.TEXT_PADDING - 2 * properties.TEXT_INNER_PADDING) + 'px';
        textArea.style.height = '5px';
        textArea.style.overflow = 'hidden';
        textArea.style.border = 'none';
        textArea.style.outline = 'none';
        textArea.style.padding = '0px';
        textArea.style.fontSize = shapeModel.fontSize + 'px';
        textArea.style.fontFamily = shapeModel.fontFamily;
        textArea.style.fontStyle = italic;
        textArea.style.fontWeight = bold;
        textArea.style.textAlign = shapeModel.fontAlign;
        textArea.style.opacity = 0;
        textArea.style.padding = properties.TEXT_INNER_PADDING;

        const textProperties = this.textProperties(shapeModel);
        textArea.style.lineHeight = textProperties.lineHeight;
        textArea.style.wordSpacing = textProperties.wordSpacing;
        textArea.textIdent = textProperties.textIdent;
        textArea.letterSpacing = textProperties.letterSpacing;

        textArea.value = shapeModel.htmlText;
    },
    getSpanWidth(fontSize, text) {
        var width;
        var divElement = document.createElement('div');
        document.body.appendChild(divElement);

        divElement.style.position = 'absolute';
        divElement.style.width = 'auto';
        divElement.style.height = 'auto';
        divElement.style.whiteSpace = 'nowrap';
        divElement.style.fontSize = fontSize + 'px';
        divElement.innerHTML = text;

        width = divElement.clientWidth  + 2;

        document.body.removeChild(divElement);

        return width;
    },
    getTextHeight(text ,width, fontSize) {
        return 30;
    },
    getTextAreaHeight(text, width, fontSize) {
        var height;
        var divElement = document.createElement('textArea');
        document.body.appendChild(divElement);

        divElement.style.width = width + 'px';
        divElement.style.height = '5px';
        divElement.style.overflow = 'hidden';
        divElement.style.border = 'none';
        divElement.style.outline = 'none';
        divElement.style.padding = '0px';
        divElement.style.whiteSpace = 'nowrap';
        divElement.style.fontSize = fontSize + 'px';
        divElement.value = text;

        var limit = divElement.scrollWidth % width;
        var offset = 0;

        if (limit > 20)
            offset = 1;

        height = (Math.floor(divElement.scrollWidth / width) + offset) * 17;

        document.body.removeChild(divElement);

        return height;
    },

    textProperties(shapeModel) {
        var properties = {};

        properties.wordSpacing = -1;
        properties.textIdent = 0;
        properties.letterSpacing = 0;

        if (shapeModel.lineHeight && shapeModel.lineHeight > 0)
            properties.lineHeight = shapeModel.lineHeight;
        else
            properties.lineHeight = 1.25;

        properties.extraPadding = 2;

        if (platformDetection.isEdge() || platformDetection.isFirefox() || platformDetection.isSafari())
            properties.extraPadding = 5;

        return properties;
    },
    correctRecordingTitle(title) {
        if (!title)
            return title;

        if (title.indexOf('.mp3') != -1)
            title = title.replace('.mp3', '');

        if (title.indexOf('January') != -1)
            title = title.replace('January', 'Jan');

        if (title.indexOf('February') != -1)
            title = title.replace('February', 'Feb');

        if (title.indexOf('March') != -1)
            title = title.replace('March', 'Mar');

        if (title.indexOf('April') != -1)
            title = title.replace('April', 'Apr');

        if (title.indexOf('June') != -1)
            title = title.replace('June', 'Jun');

        if (title.indexOf('July') != -1)
            title = title.replace('July', 'Jul');

        if (title.indexOf('August') != -1)
            title = title.replace('August', 'Aug');

        if (title.indexOf('September') != -1)
            title = title.replace('September', 'Sep');

        if (title.indexOf('October') != -1)
            title = title.replace('October', 'Oct');

        if (title.indexOf('November') != -1)
            title = title.replace('November', 'Nov');

        if (title.indexOf('December') != -1)
            title = title.replace('December', 'Dec');

        return title;
    },
    isTextEditMode() {
        if (platformDetection.isIOS()) {
            var activeElement = document.activeElement;

            if (activeElement && (activeElement.className.indexOf('textShapes') != -1 || activeElement.className.indexOf('titleInput') != -1))
                return true;
            else
                return false;
        } else
            return false;
    },
    getHtmlText(shapeModel) {
        if (shapeModel.isRichText)
            return shapeModel.htmlText;
        else {
            var htmlText = '';

            if (shapeModel.htmlText.length < 1)
                return '';

            if (shapeModel.fontAlign != 'left')
                htmlText = htmlText + '<div style="text-align:' + shapeModel.fontAlign + ';">';

            htmlText = htmlText + '<font face="' + shapeModel.fontFamily + '" color="' + shapeModel.fontColor + '">';

            if (shapeModel.fontBold == true)
                htmlText = htmlText + '<b>';

            if (shapeModel.fontItalic == true)
                htmlText = htmlText + '<i>';

            if (shapeModel.fontUnderline == true)
                htmlText = htmlText + '<u>';

            htmlText = htmlText + shapeModel.htmlText;

            if (shapeModel.fontUnderline == true)
                htmlText = htmlText + '</u>';

            if (shapeModel.fontItalic == true)
                htmlText = htmlText + '</i>';

            if (shapeModel.fontBold == true)
                htmlText = htmlText + '</b>';

            htmlText = htmlText + '</font>';

            if (shapeModel.fontAlign != 'left')
                htmlText = htmlText + '</div>';

            return htmlText;
        }
    },
    componentToHex(c) {
        var hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
    },
    rgbToHex(r, g, b) {
        return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
    },
    getHexaColor(rgbColor) {
        rgbColor = rgbColor.replace('rgb(', '');
        rgbColor = rgbColor.replace(')', '');
        var array = rgbColor.split(',');

        return this.rgbToHex(parseInt(array[0]), parseInt(array[1]), parseInt(array[2]));
    },
    getCorrectColor(color) {
        if (!color)
            return '#ffffff';

        if (color && color.indexOf('rgb(') != -1)
            color = this.getHexaColor(color);

        color = color.toLowerCase();

        return color;
    }
};

export default textSizeUtils;



/** WEBPACK FOOTER **
 ** ./src/components/utils/TextSizeUtils.js
 **/